// api.ts
import axios from 'axios'
import endpoints from '../../endpoints'
import {FleetReportBase, FleetReportPayload} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchFleetReport(
  payload: FleetReportPayload
): Promise<APIResponse<FleetReportBase[]>> {
  const response = await axios.post(API_URL + endpoints.reports.fleetReport, payload)
  return response.data
}
